//
//
//
//
//
//

export default {
  name: "PixelContent",

  computed: {
    user: function () {
      return this.$store.state.user?.user?.id
    }
  },

  watch: {
    user: function () {
      this.setScripts();
    }
  },

  mounted: function () {
    this.setScripts();
  },

  methods: {
    setScripts: function () {
      if (!this.user) {
        return
      }

      const script = `var _tmr = window._tmr || (window._tmr = []);
        _tmr.push({id: "3317020", type: "pageView", start: (new Date()).getTime(), pid: "${this.user}"});
        (function (d, w, id) {
        if (d.getElementById(id)) return;
        var ts = d.createElement("script"); ts.type = "text/javascript"; ts.async = true; ts.id = id;
        ts.src = "https://top-fwz1.mail.ru/js/code.js";
        var f = function () {var s = d.getElementsByTagName("script")[0]; s.parentNode.insertBefore(ts, s);};
        if (w.opera == "[object Opera]") { d.addEventListener("DOMContentLoaded", f, false); } else { f(); }
      })(document, window, "tmr-code");`;

      const bodyHtml = document.body.innerHTML;
      const isFind = Boolean(bodyHtml.indexOf(script) > -1);
      if (!isFind) {
        let element = document.createElement("script");
        element.innerHTML = script;
        document.body.appendChild(element);
      }
    }
  }
}
